import register from '../register.js';
import debounce from './util/debounce';

let arm = document.querySelector('.space-cowboy__arm');
let body = document.querySelector('.space-cowboy__body');
let laser = document.querySelector('.space-cowboy__laser');
let triggers = document.querySelectorAll('.space-cowboy__trigger');
let mouseArea = document.querySelector('.our-team');
let rect;
let active = false;
let isMobile;

function checkViewport() {
  if ( window.innerWidth < 768 ) {
    isMobile = true;
    return;
  }
  isMobile = false;
}

function updateCoords() {
  rect = body.getBoundingClientRect();
}

function rotateArm( e ) {
  if ( !isMobile ) {
    arm.style.transition = '';
    let x = rect.left + ( ( body.offsetWidth / 2 ) - 5 );
    let y = rect.top + ( ( body.offsetHeight / 2 ) - 20 );
    let rad = Math.atan2( e.clientX - x, e.clientY - y );
    let laserLength = getDistance( e.clientX, e.clientY, x, y );
    let rotate = ( ( rad * ( 180 / Math.PI ) * -1 ) + 180 );
    arm.style.transform = `rotate(${ rotate }deg)`;
    laser.style.transform = `rotate(${ rotate - 90 }deg)`;
    // account for cowboy being scaled down in css
    laser.style.width = `${ laserLength * 1.3 - 25 }px`;
  }
}

function getDistance( x1, y1, x2, y2 ) {
  return Math.sqrt( ( Math.pow( x2 - x1, 2 ) + Math.pow( y2 - y1, 2 ) ) );
}

function resetArm() {
  arm.style.transition = `transform 300ms ease-in-out`;
  arm.style.transform = '';
}

function toggleLaser() {
  if ( !isMobile ) {
    if ( !active ) {
      laser.style.opacity = 1;
      laser.style.animationPlayState = 'running';
      active = true;
      return;
    }
    laser.style.opacity = 0;
    laser.style.animationPlayState = 'paused';
    active = false;
  }
}

function init() {
  checkViewport();
  mouseArea.addEventListener( 'mouseenter', updateCoords );
  mouseArea.addEventListener( 'mousemove', rotateArm );
  mouseArea.addEventListener( 'mouseleave', resetArm );
  triggers.forEach( trigger => {
    trigger.addEventListener( 'mouseenter', toggleLaser );
    trigger.addEventListener( 'mouseleave', toggleLaser );
  });
  window.addEventListener( 'resize', debounce( updateCoords, 100 ) );
  window.addEventListener( 'resize', debounce( checkViewport, 300 ) );
  window.addEventListener( 'scroll', () => {
    window.requestAnimationFrame( updateCoords );
  });
}

register( 'space-cowboy', init );

export default undefined;
